module.exports = __webpack_public_path__ + "img/new_64.e32bd8a1.jpg";